import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';
import '../assets/css/Nav.css';
import ukFlag from '../assets/image/uk.png';
import saudiFlag from '../assets/image/saudi-arabia.png';

function Nav() {
    const { language } = useLanguage();
    const navigate = useNavigate();
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);

    const switchLanguage = () => {
        const newLang = language === 'en' ? 'ar' : 'en';
        // Get current path without language prefix
        const currentPath = location.pathname.replace(/^\/[a-z]{2}/, '') || '';
        // Navigate to the same page with new language
        navigate(`/${newLang}${currentPath}`);
        setIsMenuOpen(false); // Close menu after language switch
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    // Close menu when clicking outside
    React.useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && !event.target.closest('.nav_menu_container')) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [isMenuOpen]);

    return (
        <div>
            <nav className="nav_wrap">
                <div className="nav_contain">
                    <div className="nav_layout u-hflex-between-center" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        {/* Left: Logo */}
                        <a href="/" aria-current="page" className="nav_logo_link w-inline-block w--current">
                            <Logo className='logo1Nav' />
                        </a>

                        {/* Center: Nav Links (Desktop) */}
                        <ul className="nav-center-links" style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '32px',
                            listStyle: 'none',
                            margin: 0,
                            padding: 0,
                            position: 'absolute',
                            left: '50%',
                            transform: 'translateX(-50%)'
                        }}>
                            <li>
                                <a href={`/${language}`} style={{
                                    color: '#475569', fontSize: '14px', fontWeight: '500',
                                    textDecoration: 'none', transition: 'color 0.2s ease',
                                    fontFamily: '"Inter", sans-serif'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#0F172A'}
                                onMouseLeave={(e) => e.target.style.color = '#475569'}
                                >
                                    {language === 'ar' ? 'الرئيسية' : 'Home'}
                                </a>
                            </li>
                            <li>
                                <a href={`/${language}/about`} style={{
                                    color: '#475569', fontSize: '14px', fontWeight: '500',
                                    textDecoration: 'none', transition: 'color 0.2s ease',
                                    fontFamily: '"Inter", sans-serif'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#0F172A'}
                                onMouseLeave={(e) => e.target.style.color = '#475569'}
                                >
                                    {language === 'ar' ? 'عن الشركة' : 'About Us'}
                                </a>
                            </li>
                            <li>
                                <a href={`/${language}/pricing`} style={{
                                    color: '#475569', fontSize: '14px', fontWeight: '500',
                                    textDecoration: 'none', transition: 'color 0.2s ease',
                                    fontFamily: '"Inter", sans-serif'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#0F172A'}
                                onMouseLeave={(e) => e.target.style.color = '#475569'}
                                >
                                    {language === 'ar' ? 'الأسعار' : 'Pricing'}
                                </a>
                            </li>
                            <li>
                                <a href={`/${language}/contact`} style={{
                                    color: '#475569', fontSize: '14px', fontWeight: '500',
                                    textDecoration: 'none', transition: 'color 0.2s ease',
                                    fontFamily: '"Inter", sans-serif'
                                }}
                                onMouseEnter={(e) => e.target.style.color = '#0F172A'}
                                onMouseLeave={(e) => e.target.style.color = '#475569'}
                                >
                                    {language === 'ar' ? 'اتصل بنا' : 'Contact'}
                                </a>
                            </li>
                        </ul>

                        {/* Right: Language Toggle + Login + Launch App */}
                        <div className="nav_actions_wrap" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            {/* Language Toggle */}
                            <button
                                onClick={switchLanguage}
                                className="nav-lang-toggle"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                    padding: '7px 12px',
                                    background: 'transparent',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '50px',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s ease',
                                    color: '#475569',
                                    fontSize: '13px',
                                    fontWeight: '500',
                                    fontFamily: '"Inter", sans-serif',
                                    whiteSpace: 'nowrap'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#CBD5E1';
                                    e.currentTarget.style.background = '#F8FAFC';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#E2E8F0';
                                    e.currentTarget.style.background = 'transparent';
                                }}
                            >
                                <img 
                                    src={language === 'en' ? saudiFlag : ukFlag} 
                                    alt={language === 'en' ? 'Arabic' : 'English'} 
                                    style={{ width: '16px', height: '12px', borderRadius: '2px' }}
                                />
                                {language === 'ar' ? 'EN' : 'AR'}
                            </button>

                            {/* Login Button */}
                            <a 
                                href={`https://audiosum.app/login?lang=${language}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="nav-login-btn"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '8px 20px',
                                    background: '#F8FAFC',
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '50px',
                                    color: '#0F172A',
                                    textDecoration: 'none',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    transition: 'all 0.2s ease',
                                    whiteSpace: 'nowrap',
                                    fontFamily: '"Inter", sans-serif'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.borderColor = '#CBD5E1';
                                    e.currentTarget.style.background = '#F1F5F9';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.borderColor = '#E2E8F0';
                                    e.currentTarget.style.background = '#F8FAFC';
                                }}
                            >
                                {language === 'ar' ? 'تسجيل الدخول' : 'Login'}
                            </a>

                            {/* Launch App Button */}
                            <a 
                                href={`https://audiosum.app/signup?lang=${language}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="nav-launch-btn"
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '8px 20px',
                                    background: 'linear-gradient(135deg, #6C3AED, #0EA5E9)',
                                    border: 'none',
                                    borderRadius: '50px',
                                    color: 'white',
                                    textDecoration: 'none',
                                    fontSize: '13px',
                                    fontWeight: '600',
                                    transition: 'all 0.3s ease',
                                    whiteSpace: 'nowrap',
                                    fontFamily: '"Inter", sans-serif',
                                    boxShadow: '0 4px 15px rgba(108, 58, 237, 0.3)'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(108, 58, 237, 0.4)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 4px 15px rgba(108, 58, 237, 0.3)';
                                }}
                            >
                                {language === 'ar' ? 'تشغيل التطبيق' : 'Launch App'}
                            </a>

                            {/* Mobile Hamburger Menu */}
                            <div className="nav_menu_container nav-mobile-only" style={{ position: 'relative' }}>
                                <button 
                                    onClick={toggleMenu}
                                    className="menu_button"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '40px',
                                        height: '40px',
                                        background: '#F8FAFC',
                                        border: '1px solid #E2E8F0',
                                        borderRadius: '10px',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s ease',
                                        color: '#0F172A',
                                        padding: 0
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = '#CBD5E1';
                                        e.currentTarget.style.background = '#F1F5F9';
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = '#E2E8F0';
                                        e.currentTarget.style.background = '#F8FAFC';
                                    }}
                                >
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" 
                                        style={{ transform: isMenuOpen ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.3s ease' }}>
                                        <path d="M3 12H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                        <path d="M3 6H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                        <path d="M3 18H21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/>
                                    </svg>
                                </button>

                                {/* Mobile Dropdown */}
                                {isMenuOpen && (
                                    <div 
                                        className="dropdown_menu"
                                        style={{
                                            position: 'absolute',
                                            top: '100%',
                                            right: '0',
                                            marginTop: '12px',
                                            background: 'rgba(255, 255, 255, 0.98)',
                                            backdropFilter: 'blur(20px)',
                                            borderRadius: '16px',
                                            boxShadow: '0 20px 50px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.04)',
                                            border: '1px solid #E2E8F0',
                                            minWidth: '220px',
                                            zIndex: 1000,
                                            overflow: 'hidden',
                                            animation: 'dropdownFade 0.3s ease-out'
                                        }}
                                    >
                                        {[
                                            { href: `/${language}`, label: language === 'ar' ? 'الرئيسية' : 'Home' },
                                            { href: `/${language}/about`, label: language === 'ar' ? 'عن الشركة' : 'About Us' },
                                            { href: `/${language}/pricing`, label: language === 'ar' ? 'الأسعار' : 'Pricing' },
                                            { href: `/${language}/contact`, label: language === 'ar' ? 'اتصل بنا' : 'Contact' },
                                            { href: `/${language}/terms-of-service`, label: language === 'ar' ? 'شروط الخدمة' : 'Terms of Service' },
                                            { href: `/${language}/privacy-policy`, label: language === 'ar' ? 'سياسة الخصوصية' : 'Privacy Policy' },
                                        ].map((item, i) => (
                                            <a 
                                                key={i}
                                                href={item.href}
                                                style={{
                                                    display: 'block',
                                                    padding: '14px 20px',
                                                    textDecoration: 'none',
                                                    color: '#475569',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    borderBottom: '1px solid #F1F5F9',
                                                    transition: 'all 0.2s ease',
                                                    fontFamily: '"Inter", sans-serif'
                                                }}
                                                onMouseEnter={(e) => {
                                                    e.target.style.background = '#F8FAFC';
                                                    e.target.style.color = '#6C3AED';
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.target.style.background = 'none';
                                                    e.target.style.color = '#475569';
                                                }}
                                                onClick={() => setIsMenuOpen(false)}
                                            >
                                                {item.label}
                                            </a>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
            
        </div>

    )
}

export default Nav
